import type { ProgramMembershipFragment } from 'bundles/program-home/queries/__generated__/ProgramMembershipsQuery';
import type { ProgramMembershipEdge } from 'bundles/unified-common/contexts/UserExperienceMembershipsContext';

type MembershipNode = NonNullable<NonNullable<ProgramMembershipEdge>['node']>;

/**
 * Maps a node from UserExperienceMembershipsQuery to ProgramMembershipFragment.
 * Fields unavailable in UserExperienceMembershipsQuery (createdAt, userData) are
 * defaulted to empty values — the ProgramMembership constructor handles these gracefully.
 */
const mapUserExperienceMembershipToProgramMembershipFragment = (node: MembershipNode): ProgramMembershipFragment => ({
  __typename: 'ProgramMemberships_ProgramMembership',
  id: node.id,
  createdAt: '',
  state: node.state,
  emailVerified: node.emailVerified,
  userData: {
    __typename: 'ProgramMemberships_UserData',
    fullName: '',
    email: '',
  },
});

export default mapUserExperienceMembershipToProgramMembershipFragment;
